import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const PublicRoute = () => {
  if (isAuthenticated()) {
    // Already logged in → redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }
  // Not logged in → allow access to public pages (e.g. Login)
  return <Outlet />;
};

export default PublicRoute;